import { createAsyncThunk } from '@reduxjs/toolkit';
import { PropertySubCategory } from '../../../client/services';
import { toastHandler } from '../../../utils/toastHandler';
import {
  FindPropertySubCategory,
  GetPropertySubCategory,
} from '../../propertySubCategory/api/interface';

export const findSelectPropertySubCategory = createAsyncThunk(
  'selectPropertySubCategory/findSelectPropertySubCategory',
  async (values: FindPropertySubCategory, { rejectWithValue }) => {
    try {
      const response = await PropertySubCategory.find({
        query: values,
      });
      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

export const searchSelectPropertySubCategory = createAsyncThunk(
  'selectPropertySubCategory/searchSelectPropertySubCategory',
  async (values: FindPropertySubCategory, { rejectWithValue }) => {
    try {
      const response = await PropertySubCategory.find({
        query: values,
      });
      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

export const getSelectPropertySubCategory = createAsyncThunk(
  'selectPropertySubCategory/getSelectPropertySubCategory',
  async ({ id }: GetPropertySubCategory, { rejectWithValue }) => {
    try {
      const response = await PropertySubCategory.get(id);

      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);
